import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { CollectibleIcon } from '../collectible-icon';

interface CollectibleXPToastProps {
  code: string;
  xp: number
  isXPAdded: boolean
}

const CollectibleXPToast: React.FC<CollectibleXPToastProps> = (props) => {

  const { code, xp, isXPAdded } = props;

  const displayXpGain = (code: string, xp:number) => {

    toast.dismiss();

    if (isXPAdded) {
      toast(
        <p className='text-white font-light'>
          <span className='font-bold'>{code}</span> collectible card <br/>
          gains <span className='font-bold'>{xp} XP</span>
        </p>
      , {
        position: 'bottom-center',
        icon: <CollectibleIcon widthCss={"w-6"}/>,
        style: {
          background: '#000',
          padding: '8px',
          paddingLeft: '12px',
          paddingRight: '12px',
          marginBottom: '35px',
        }
      });
    } else {
      toast(
        <p className='text-white font-light'>
          <span className='font-bold'>{code}</span> collectible card <br/>
          Upgrade available in the <span className='font-bold'>SHOP</span>
        </p>
        , {
          position: 'bottom-center',
          icon: <CollectibleIcon widthCss={"w-6"} />,
          style: {
            background: '#000',
            padding: '8px',
            paddingLeft: '12px',
            paddingRight: '12px',
            marginBottom: '35px',
          }
        });
    }

  }

  useEffect(() => {
    displayXpGain(code, xp);
  }, []);

  return (<></>);

}

export default CollectibleXPToast;